import { PayloadAction } from '@reduxjs/toolkit';

import {
  mParticleSetUserGoatId,
  mParticleSetUserLoggedIn,
  mParticleSetUserLoggedOut,
} from 'tracking/utils/mParticleServiceMethods';
import { IAuth, IUserAction, IAuthenticated } from 'store/types/authTypes';
import { IUser } from 'auth/types/User';

export const login = (state: IAuth, action: PayloadAction<IUserAction>) => {
  const { user, eventContext, accountCreation, clientDedupID } = action?.payload;
  state.isAuthenticated = true;
  state.user = user;
  mParticleSetUserLoggedIn({
    user,
    eventContext,
    accountCreation,
    clientDedupID,
  });
};

export const logout = (state: IAuth) => {
  state.isAuthenticated = false;
  state.user = null;
  mParticleSetUserLoggedOut();
};

export const setIsUserAuthenticated = (
  state: IAuth,
  action: PayloadAction<IAuthenticated['isAuthenticated']>,
) => {
  state.isAuthenticated = action.payload;
};

export const setUser = (state: IAuth, action: PayloadAction<IUser>) => {
  state.isAuthenticated = true;
  state.user = action.payload;
  mParticleSetUserGoatId({ user: action?.payload });
};

export const setStoreClientDedupID = (
  state: IAuth,
  action: PayloadAction<IUserAction['clientDedupID']>,
) => {
  state.clientDedupID = action.payload;
};
